import { FEATURE_FLAG_BYPASS } from '../utils/featureFlags';

/**
 * Feature Flag to Navigation Menu Mapping
 *
 * This configuration maps menu item names to their corresponding feature flags.
 * Used by the SideNav component to filter navigation items based on enabled features.
 */

export const MENU_FEATURE_MAP = {
  // Main Navigation - Top Level
  'Settings': 'settings',

  // Main Navigation - Customers Section
  'Customers': null, // Parent - show if any child is enabled
  'Companies': 'companies',
  'Contacts': 'contacts',

  // Main Navigation - Sell Section
  'Sell': null, // Parent - show if any child is enabled
  'Proposals': 'proposals',
  'Self serve users': 'selfServeUsers',
  'Upsells / Downsells': 'upsellsDownsells',

  // Main Navigation - Collect Section
  'Collect': null, // Parent - show if any child is enabled
  'Invoices': 'invoices',
  'Payments': 'payments',
  'Subscriptions': 'subscriptions',

  // Main Navigation - Catalogue Section
  'Catalogue': null, // Parent - show if any child is enabled
  'Plans': 'plans',
  'Products & Add Ons': 'productsAddOns',
  'Markets': 'markets',
  'Events': 'events',

  // Main Navigation - JSON Viewer (Development)
  'JSON Viewer': 'jsonViewer',

  // Settings Navigation
  'Your profile': 'yourProfile',
  'Organisation details': 'organisationDetails',
  'Integrations': 'integrations',
  'Platform Settings': 'platformSettings',

  // Settings Navigation - Configure Billing Section
  'Configure billing': null, // Parent - show if any child is enabled
  'Billing units': 'billingUnits',
  'Usage sources': 'usageSources',
  'Usage compilation': 'usageCompilation',
  'Usage collection': 'usageCollection',
  'System features': 'systemFeatures',

  'Billing logic': 'billingLogic',
  'Configure Self-checkout': 'configureSelfCheckout',

  // Settings Navigation - Users & Roles Section
  'Users & Roles': null, // Parent - show if any child is enabled
  'User management': 'userManagement',
  'Roles': 'roles',
  'Permissions': 'permissions',

  // Settings Navigation - Imports & Exports Section
  'Imports & Exports': null, // Parent - show if any child is enabled
  'Imports': 'imports',
  'Migrations': 'migrations',
  'Exports': 'exports',

  // Settings Navigation - Customizations Section
  'Customizations': null, // Parent - show if any child is enabled
  'Document management': 'documentManagement',
  'Object customization': 'objectCustomization',
  'Webhooks': 'webhooks',
  'Time Machine': 'timeMachine',
};

/**
 * Quick Actions Feature Flags
 */
export const QUICK_ACTIONS_FEATURE_MAP = {
  'Company': 'companyQuickAction',
  'Proposal': 'proposalQuickAction',
  'Subscription': 'subscriptionQuickAction',
  'Invoice': 'invoiceQuickAction',
};

/**
 * Get feature flag for a quick action
 * @param {string} actionName - Quick action name
 * @returns {string|null} - Feature flag name or null
 */
export function getFeatureFlagForQuickAction(actionName) {
  return QUICK_ACTIONS_FEATURE_MAP[actionName] || null;
}

/**
 * Check if a quick action should be shown based on feature flags
 * @param {string} actionName - Quick action name
 * @param {object} featureFlags - Feature flags object
 * @returns {boolean} - True if quick action should be shown
 */
export function shouldShowQuickAction(actionName, featureFlags) {
  if (FEATURE_FLAG_BYPASS) {
    return true;
  }

  const featureFlag = getFeatureFlagForQuickAction(actionName);

  // If no feature flag is defined, show the action
  if (!featureFlag) {
    return true;
  }

  // Check if feature is enabled
  return featureFlags[featureFlag] === true;
}
